<div class="groupmember-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="false">
  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-member-order-icon title-margin">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
      </div>
    </div>
    <div class="group-member-order_title">
      <h2 class="title" langkey="phGroupOrder_MemberOrder_Detail_Label"></h2>
      <ng-container *ngIf="memberInfo$ |async; let member">
        <div class="member-info">
          <h3 class="title name">{{member.name}}</h3>
          <ng-container *ngIf="isOwner && member.readyForPickUpCount">
            <div class="mat-badge" [matBadge]="member.readyForPickUpCount" matBadgeOverlap="false" matBadgeSize="small"
              matBadgePosition="below">
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <!-- notification state-->
    <ng-container *ngIf="isOwner && useEPing">
      <div class="notification-content">
        <div class="notification-header_icon">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-handy-notification"></div>
          </div>
        </div>
        <div class="notification_wrapper">
          <ng-container *ngIf="memberInfo$ |async; let member">
            <ng-container
              *ngIf="member.notificationTyp !== IMemberInfo_NotificationTyp.NONE; then NotificationTemplate else NoNotificationTemplate">
            </ng-container>
            <ng-template #NotificationTemplate>
              <ng-container *ngIf="member.notificationTyp === IMemberInfo_NotificationTyp.WebPush">
                <div class="notification_label">
                  <span langkey="phInHouse_Push_Notification"></span>
                </div>
              </ng-container>
              <ng-container *ngIf="member.notificationTyp === IMemberInfo_NotificationTyp.FCM">
                <div class="notification_label">
                  <span langkey="phInHouse_Push_Notification"></span>
                </div>
              </ng-container>
              <ng-container *ngIf="member.notificationTyp === IMemberInfo_NotificationTyp.SMS">
                <div class="notification_label">
                  <span [innerHtml]="SMSNotificationLabel"></span>
                </div>
                <div class="change-number_icon" (click)="ChangePhoneNumber()">
                  <div class="icon-container">
                    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-edit_FILL"></div>
                  </div>
                </div>
              </ng-container>
            </ng-template>
            <ng-template #NoNotificationTemplate>
              <span langkey="phInHouse_No_Notification">
              </span>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="group-member-order_label">
      <h3 class="title order" langkey="phGroupOrder_MemberOrder_Detail_Basket_Label"></h3>
    </div>
    <div class="divider"></div>
    <!-- Currently items in the group basket -->
    <ng-container *ngIf="memberGroupBasketItems$ | async; let basketItems">
      <ng-container *ngIf="basketItems.length> 0; then basketTemplate else emptybasketTemplate"></ng-container>
      <ng-template #basketTemplate>
        <div class="basket-content">
          <div class="col">
            <div [@slideInFade] class="ya-item-list-contaner">
              <ng-container *ngFor="let basketItem of basketItems; let itemIndex=index">
                <ya-basketItemCard [basketItem]="basketItem" [canModifyBasket]="isOwner || isGroupCreator()"
                  [menucourses$]="menucourses$" [isInHouseGroupOrder]="true"></ya-basketItemCard>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #emptybasketTemplate>
        <div class="empty-Content">
          <div class="empty_info">
            <h3 class="title" langkey="phGroupOrder_MemberOrder_Detail_Empty_Basket"> </h3>
          </div>
          <div class="order_detail_btn">
            <div class="ya-webshop-button-container">
              <button mat-flat-button [disabled]="!isOwner" (click)="navigateToMenuGroup()">
                <span langkey="phGroupOrder_MemberOrder_Detail_OrderNow_Btn"></span></button>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
    <!-- Ordered items-->
    <div class="group-member-order_label">
      <h3 class="title" langkey="phGroupOrder_MemberOrder_Detail_Ordered_Label"></h3>
    </div>
    <div class="divider"></div>
    <ng-container *ngIf="memberOrderedItems$ | async; let orderedItems">
      <ng-container *ngIf="orderedItems.length > 0; then orderedTemplate else emptyOrderTemplate"></ng-container>
      <ng-template #orderedTemplate>
        <div class="ordered_content">
          <div [@slideInFade] class="ya-item-list-contaner">
            <ng-container *ngFor="let orderedItem of orderedItems; let itemIndex=index">
              <ya-basketItemCard [OrderedItem]="orderedItem" [isInHouseGroupOrder]="true"
                [canModifyBasket]="false"></ya-basketItemCard>
            </ng-container>
          </div>
          <div class=" price-container">
            <span langkey="phGroupOrder_MemberOrder_Detail_Total_Label"></span>
            <span>{{formatCurrency(open_price$|async)}}</span>
          </div>
          <ng-container *ngIf="isOwner">
            <div class="order_detail_btn">
              <div class="ya-webshop-button-container">
                <button mat-flat-button (click)="navigateToPayment()"><span
                    langkey="phGroupOrder_MemberOrder_Detail_PayNow_Btn"></span></button>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <!--#empty order-->
      <ng-template #emptyOrderTemplate>
        <div class="empty-Content">
          <div class="empty_info">
            <h3 class="title" langkey="phGroupOrder_MemberOrder_Detail_Empty_Order"> </h3>
          </div>
          <div class="order_detail_btn">
            <div class="ya-webshop-button-container">
              <button mat-flat-button disabled><span
                  langkey="phGroupOrder_MemberOrder_Detail_PayNow_Btn"></span></button>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>